/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from 'react';

import AuthService from '../../state/auth.service';
import Button from '../form/Button';
import FileApi from '../../api/file';
import FileCard from './FileCard';
import Bar from '../chart/Bar';
import Message from '../form/Message';

class FilesCard extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      newFiles: [],
      message: null,
      uploadComplete: 0,
    };

    this.canUpload = this.canUpload.bind(this);
    this.getUploadControls = this.getUploadControls.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);
  }

  onUploadProgress() {
    return progressEvent => {
      let percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      this.setState({ uploadComplete: percentCompleted });
    };
  }

  uploadFiles(evt) {
    const fileList = Array.from(evt.files);
    const criterionId = this.props.criterion.id;

    fileList.forEach(file => {
      console.log('Uploading: ' + file.name);

      FileApi.getUploadURL(criterionId)
        .then(urlObj => {
          console.log(urlObj);

          FileApi.putFile(urlObj.url, file, this.onUploadProgress()).then(
            rtv => {
              let newFiles = this.state.newFiles;
              newFiles.push({
                s3_id: file.name,
                file_key: urlObj.fname,
                criterion_id: criterionId,
              });
              console.log('New Files: ' + JSON.stringify(newFiles));
              this.setState({ newFiles: newFiles });
              FileApi.postFileMetadata(criterionId, file.name, urlObj.fname);
            }
          );
        })
        .catch(error => {
          this.setState({
            message: 'Unable to upload file.',
          });
        });
    });
  }

  chooseFile() {
    this.input.click();
  }

  canUpload() {
    const user = AuthService.getUser();
    if (
      user &&
      (user.role === 'Administrator' ||
        user.role === 'Document Provider' ||
        user.role === 'Restricted')
    ) {
      return true;
    }
    return false;
  }

  getUploadControls() {
    return (
      <div className="FileUploadControls">
        <span className="hidden">
          <input
            type="file"
            value={this.state.file}
            ref={input => (this.input = input)}
            onChange={e => this.uploadFiles(e.target)}
          />
        </span>
        <div className="FileUploadButton">
          <Button
            defaultText="Upload File"
            busyText="Uploading File..."
            icon="fa-cloud-upload"
            onClick={e => this.chooseFile()}
          />
        </div>
        <div
          className={
            (this.state.uploadComplete === 0 ? 'hidden' : '') +
            // + (this.state.uploadComplete==100?"hidden" : "")
            ` UploadStatusBar`
          }>
          Upload progress ({this.state.uploadComplete}%):
          <Bar
            status="good"
            orientation="horizontal"
            completed={this.state.uploadComplete}>
            {' '}
          </Bar>
        </div>
      </div>
    );
  }

  render() {
    const criterion = this.props.criterion || {};
    let files = criterion.files || [];
    files = files.concat(this.state.newFiles);
    let uploadControls = null;
    if (this.canUpload()) {
      uploadControls = this.getUploadControls();
    }

    return (
      <div className="FilesCard">
        {files.map(file => {
          return <FileCard key={file.file_key} file={file} />;
        })}
        {uploadControls}
        {this.props.disableCriterion && (
          <Message
            info={`${criterion.code} is a shared criterion in a non-primary practice. Files uploaded here will not appear in the ${criterion.code} criterion page in the primary practice.`}
          />
        )}
      </div>
    );
  }
}

export default FilesCard;
